<template>
  <Layout>
    <template v-slot:header>
      <Nav customer="admin" />
    </template>

    <v-container>
      <h1>{{$t('admin.customerManagement.pageTitle')}}</h1>
      <CustomerList :customers="customers" :onEdit="editCustomer" :onChange="loadCusgtomers" class="mb-5" />

      <v-btn @click="addCustomer">{{$t('admin.customerManagement.addCustomer')}}</v-btn>

      <PropPanel ref="detailPanel" :onSave="saveCustomer" :tabIndex="3">
        <CustomerForm ref="customerForm" :onSuccess="savedCustomer" />
      </PropPanel>
    </v-container>
  </Layout>
</template>

<script>
import axios from "axios";

import Layout from "@/layouts/default";

import Nav from "@/components/_layout/navigation";
import PropPanel from "@/components/_common/proppanel.vue";
import CustomerList from "@/components/customers/customerlist.vue";
import CustomerForm from "@/components/customers/customerform";

export default {
  name: "AdminCustomers",
  components: {
    Layout,
    PropPanel,
    CustomerList,
    CustomerForm,
    Nav
  },

  data() {
    return {
      customers: [],
    };
  },

  created() {
    this.loadCusgtomers();
  },

  methods: {
    loadCusgtomers: function() {
      this.$store.dispatch("loading", true);
      axios
        .get(`/api/customers`)
        .then((response) => {
          this.customers = response.data;
          this.$store.dispatch("loading", false);
        })
        .catch((e) => {
          console.log(e);
          this.$store.dispatch("loading", false);
        });
    },

    addCustomer: function() {
      this.$refs.customerForm.init();
      this.$refs.detailPanel.show();
    },

    editCustomer: function(customer) {
      this.$refs.customerForm.init(customer.id);
      this.$refs.detailPanel.show();
    },

    saveCustomer: function() {
      this.$refs.customerForm.save();
    },

    savedCustomer: function() {
      this.$refs.detailPanel.hide();
      this.loadCusgtomers();
    },
  },
};
</script>
